var _rect, _rect2, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMaybe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "#D3D8DE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.10358 5.62912C6.92471 5.78089 6.79181 6.01333 6.79181 6.36648C6.79181 6.64262 6.56795 6.86648 6.29181 6.86648C6.01567 6.86648 5.79181 6.64262 5.79181 6.36648C5.79181 5.72531 6.04953 5.21201 6.4566 4.86661C6.8528 4.53044 7.36325 4.375 7.85431 4.375C8.34537 4.375 8.85582 4.53045 9.25202 4.86662C9.65909 5.21201 9.91681 5.72531 9.91681 6.36648C9.91681 6.81551 9.80141 7.16149 9.61089 7.44728C9.45231 7.68513 9.24631 7.86886 9.0905 8.00781C9.07337 8.02309 9.05685 8.03783 9.04106 8.05204C8.86705 8.20864 8.74348 8.33132 8.65343 8.49042C8.56827 8.64085 8.49635 8.85567 8.49635 9.20735C8.49635 9.4835 8.2725 9.70735 7.99635 9.70735C7.72021 9.70735 7.49635 9.4835 7.49635 9.20735C7.49635 8.70676 7.60199 8.31789 7.78317 7.99781C7.95946 7.68639 8.191 7.47172 8.37211 7.30873C8.38524 7.29691 8.39805 7.2854 8.41052 7.27419C8.58391 7.1184 8.69458 7.01896 8.77884 6.89257C8.85465 6.77886 8.91681 6.62768 8.91681 6.36648C8.91681 6.01334 8.78391 5.78089 8.60504 5.62913C8.4153 5.46814 8.1445 5.375 7.85431 5.375C7.56411 5.375 7.29332 5.46813 7.10358 5.62912Z",
    fill: "#545A62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33863 10.5446C8.54388 10.7293 8.56052 11.0454 8.37579 11.2507L8.37163 11.2553C8.1869 11.4606 7.87075 11.4772 7.6655 11.2925C7.46024 11.1078 7.4436 10.7916 7.62833 10.5864L7.6325 10.5817C7.81723 10.3765 8.13337 10.3598 8.33863 10.5446Z",
    fill: "#545A62"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaybe);
export default __webpack_public_path__ + "static/media/Maybe.b14ad9356b685cd3c7d6d1c92de976b7.svg";
export { ForwardRef as ReactComponent };